import { graphql } from "gql/gql";
import { request } from "graphql-request";
import {
    buildRequestHeaders,
    buildFootprintRequestVariables,
} from "utils/helpers";
import { BACKEND_DOMAIN } from "utils/constants";

const queryFn = (
    accessToken: string,
    address: Address,
    grossFloorArea: number,
    floorsAboveGrade: number
) =>
    request({
        url: `${BACKEND_DOMAIN}/graphql`,
        document: query,
        variables: buildFootprintRequestVariables(address, grossFloorArea, floorsAboveGrade),
        requestHeaders: buildRequestHeaders(accessToken),
    }).then((data) => data.buildingFootprints as BuildingFootprints);

const query = graphql(`
    query buildingFootprints($address: Address!, $grossFloorArea: Float!, $floorsAboveGrade: Int!) {
        buildingFootprints(address: $address, grossFloorArea: $grossFloorArea, floorsAboveGrade: $floorsAboveGrade) {
            error
            closestBuildingUid
            features {
                type
                geometry {
                    type
                    coordinates
                }
                properties {
                    latitude
                    longitude
                    buildingUid
                }
            }
            latitude
            longitude
        }
    }
`);

export default queryFn;
